import EditTermContainer from "./EditTermContainer";
export default EditTermContainer;
